"use client"
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__hooks_use_mobile_mjs_dd603bfc__ from "../../hooks/use-mobile.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__ from "../../lib/utils.mjs";
function FiltersResponsive({ children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: children
    });
}
function FiltersDesktop({ children, className, ...props }) {
    const isMobile = (0, __WEBPACK_EXTERNAL_MODULE__hooks_use_mobile_mjs_dd603bfc__.useIsMobile)();
    if (isMobile) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: className,
        ...props,
        children: children
    });
}
function FiltersMobile({ children, className, ...props }) {
    const isMobile = (0, __WEBPACK_EXTERNAL_MODULE__hooks_use_mobile_mjs_dd603bfc__.useIsMobile)();
    if (!isMobile) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: className,
        ...props,
        children: children
    });
}
function FiltersContainer({ children, className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("flex w-full items-start justify-between gap-2", className),
        ...props,
        children: children
    });
}
function FiltersMain({ children, className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("flex md:flex-wrap gap-2 w-full flex-1", className),
        ...props,
        children: children
    });
}
function FiltersActions({ children, className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("flex items-center gap-2", className),
        ...props,
        children: children
    });
}
export { FiltersActions, FiltersContainer, FiltersDesktop, FiltersMain, FiltersMobile, FiltersResponsive };
